import { render } from "./interactions.vue?vue&type=template&id=fec259ac"
import script from "./interactions.js?vue&type=script&lang=js"
export * from "./interactions.js?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__